<span class="selected-jobs-summary-detail" [title]="selectedJobCountTooltip">
    {{ selectedJobCountStr }}
</span>
